module.exports = __webpack_public_path__ + "img/arrow-back.8f39a211.svg";